export default "__VITE_ASSET__Sq3y15lA__";